// extracted by mini-css-extract-plugin
module.exports = {"altHero":"xj","altProd":"yj","subheading":"zj","subtext":"Aj","extrainfo":"Bj","copy":"Cj","cta":"Dj","disabled":"Ej"};